import DateTime from "utils/DateTime";
import Uuid from "utils/Uuid";

const futureDate = DateTime.addDuration(DateTime.now(), 3, "months");
const startOfWorkOrder = DateTime.startOfMonth(futureDate);
const endOfWorkOrder = DateTime.endOfMonth(futureDate);

const sampleBlock = {
  effectiveLabor: 10,
  efficiencyOverride: 1,
  laborOverride: null,
  performanceOverride: 1,
  standardProductionRate: 20,
  workOrder: {
    code: "Work order code",
    customerName: "Customer",
    customWorkOrderFieldSelections: [
      {
        customWorkOrderField: { id: "field-1", label: "Custom Field" },
        customWorkOrderFieldValue: { description: "Custom value", id: "value-1", indicator: "orange" },
        id: "selection-1",
      },
    ],
    description: "Work order description",
    due: endOfWorkOrder,
    externalId: "Work order ID",
    itemCode: "Item code",
    itemDescription: "Item description",
    unitOfMeasure: "cases",
  },
  workTimeEndsAt: DateTime.addDuration(DateTime.now(), 2, "hours"),
  workTimeStartsAt: DateTime.now(),
};

const sampleWorkOrder = {
  code: "Work order code",
  completed: false,
  customerName: "Customer",
  customWorkOrderFieldSelections: [],
  description: "Production of sample item 123",
  due: endOfWorkOrder,
  endAt: endOfWorkOrder,
  externalId: "0000123",
  externalUuid: Uuid.generate(),
  id: Uuid.generate(),
  itemCategory: {
    name: "Category Y",
  },
  itemClass: {
    name: "Class A",
  },
  itemCode: "ITEM-123",
  itemDescription: "Sample item 123",
  itemFamily: {
    name: "Family 1",
  },
  itemRecommendation: {
    recommendedPeople: 8,
    recommendedProductionRate: 1200,
  },
  itemType: {
    name: "Type X",
  },
  materialAvailabilityDate: startOfWorkOrder,
  producedQuantity: 12000,
  quantity: 20000,
  reference1: "123",
  reference2: "456",
  reference3: "789",
  reference4: "890",
  reference5: "901",
  remainingDuration: 6 * 60 * 60,
  schedulable: false,
  scheduledDuration: 14 * 60 * 60,
  scheduledQuantity: 14000,
  scheduledStatus: "underscheduled",
  serviceCategory: {
    name: "Service category Z",
  },
  standardPeople: 10,
  standardProductionRate: 1000,
  startAt: startOfWorkOrder,
  status: "open",
  unitOfMeasure: "cases",
  unschedulable: false,
  unscheduledQuantity: 6000,
  workOrderPriority: {
    description: "High priority",
    priority: 1,
  },
};

export { sampleBlock, sampleWorkOrder };
